module.exports = __webpack_public_path__ + "img/coin-gem-exchange.3c2d4918.png";